import { Card, Col, Row, Image } from 'react-bootstrap';
import moment from 'moment';
import icUserCircle from './assets/img/ic-user-circle.svg';
import icLogin from './assets/img/ic-login-shape.svg';
import icDataUpdate from './assets/img/ic-table-refresh.svg';
import icSubscription from './assets/img/ic-coins.svg';

const CompanyStats = ({ createdAt, updatedAt, accessLevel }) => {
  return (
      <Card className="mb-4 bg">
          <Card.Body>
                <h3>Stats</h3>
                <hr />
                <Row>
                    <Col md={3}>
                        <div className="icon-text">
                            <span className="icon" aria-hidden="true">
                                <Image
                                    src={icUserCircle}
                                    alt="Initial Registration"
                                />
                            </span>
                            <span className="text">
                                Initial Registration:
                                <br />
                                <strong>{createdAt ? moment(createdAt).format('DD.MM.YYYY') : 'N/A'}</strong>
                            </span>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="icon-text">
                            <span className="icon" aria-hidden="true">
                                <Image
                                    src={icLogin}
                                    alt="Latest user login"
                                />
                            </span>
                            <span className="text">
                                Latest user login:
                                <br />
                                <strong>N/A</strong>
                            </span>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="icon-text">
                            <span className="icon" aria-hidden="true">
                                <Image
                                    src={icDataUpdate}
                                    alt="Latest data update"
                                />
                            </span>
                            <span className="text">
                                Latest data update:
                                <br />
                                <strong>{updatedAt ? moment(updatedAt).format('DD.MM.YYYY HH:mm') : 'N/A'}</strong>
                            </span>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="icon-text">
                            <span className="icon" aria-hidden="true">
                                <Image
                                    src={icSubscription}
                                    alt="Subscription tier"
                                />
                            </span>
                            <span className="text">
                                Subscription tier:
                                <br />
                                <strong>{accessLevel ? accessLevel : 'N/A'}</strong>
                            </span>
                        </div>
                    </Col>
                </Row>
          </Card.Body>
      </Card>
  );
};

export default CompanyStats;

